import * as yup from 'yup'
import { PATTERNS } from '../helpers/constants/ValidationPatterns'

export const ProfileSettingsValidationSchema = yup.object().shape({
  firstName: yup.string().trim().required('First name is required'),
  lastName: yup.string().trim().required('Last name is required'),
  email: yup.string().trim().required('Email is required'),
  phoneNumber: yup
    .string()
    .trim()
    .min(10)
    .max(10)
    .typeError('Phone number is invalid')
    .required('Phone number is required'),
})

export const ChangePasswordValidationSchema = yup.object().shape({
  currentPassword: yup.string().trim().required('Current password is required'),
  newPassword: yup
    .string()
    .trim()
    .required('New password is required')
    .matches(
      PATTERNS.PASSWORD,
      'Must contain 8 characters, one lowercase, one uppercase, one number and one special case character'
    )
    .test(
      'should-not-match-current-password',
      'New password should not match the current password',
      function (value) {
        return value != this.parent.currentPassword
      }
    ),
  confirmPassword: yup
    .string()
    .trim()
    .required('Confirm password is required')
    .oneOf(
      [yup.ref('newPassword'), null],
      'Passwords must match'
    ),
  oldPassword: yup.string(),
})

export const CompanyProfileValidations = yup.object().shape({
  name: yup.string().trim().required('Name is required'),
  street: yup.string().notRequired(),
  streetNumber: yup.string().trim().required('Address line-1 is required'),
  city: yup.string().trim().required('City is required'),
  state: yup.string().trim().required('State is required'),
  zipCode: yup
    .string()
    .matches(/^\d{5}$/, 'Zip code must be exactly 5 digits')
    .required('Zip code is required'),
  country: yup.string().trim().required('Country is required'),
  phone: yup.number().required('Phone is required'),
})

export const ContactFormValidation = yup.object().shape({
  firstName: yup.string().trim().required('Enter First Name'),
  lastName: yup.string().trim().required('Enter Last Name'),
  email: yup.string().trim().email('Invalid email.').required('Email Required'),
  phone: yup
    .string()
    .trim()
    .min(10, 'Phone number should be 10 digit')
    .max(10, 'Phone number should be 10 digit')
    .required('Phone number Required'),
  mobile: yup
    .string()
    .trim()
    .nullable()
    .min(10, 'Mobile number should be 10 digit')
    .max(10, 'Mobile number should be 10 digit'),
  fax: yup
      .string()
    .trim()
    .nullable()
    .min(10, 'Fax should be 10 digit')
    .max(10, 'Fax should be 10 digit'),
})

export const ContactBillingFormValidation = yup.object().shape({
  companyName: yup.string().trim().required('Enter Company Name'),
})
